module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1234.9fc4800d.png";